import { AssetTypes } from 'libs.localization.common';
import { ParticipantStatusesPreview, ProtocolSchedulePreview, ResourcesPreview, SignInSupportInformationPreview, StudyNameWithPIIPreview, StudyNameWithNoPIIPreview, ActivityNamesPreview, SiteVisitSchedulePreview, ResourceTitlesPreview, PushNotificationPreview, EmailPreview, SmsPreview, } from './components';
import { StudyNameWithMixPIIPreview as StudyNameWithMixPIIPreviewR520, StudyNameWithPIIPreview as StudyNameWithPIIPreviewR520, } from './components_520';
import { ParticipantStatusesPreview as ParticipantStatusesPreviewR400, ProtocolSchedulePreview as ProtocolSchedulePreviewR400, ResourcesPreview as ResourcesPreviewR400, SignInSupportInformationPreview as SignInSupportInformationPreviewR400, StudyNameWithPIIPreview as StudyNameWithPIIPreviewR400, StudyNameWithNoPIIPreview as StudyNameWithNoPIIPreviewR400, ActivityNamesPreview as ActivityNamesPreviewR400, SiteVisitSchedulePreview as SiteVisitSchedulePreviewR400, ResourceTitlesPreview as ResourceTitlesPreviewR400, PushNotificationPreview as PushNotificationPreviewR400, EmailPreview as EmailPreviewR400, SmsPreview as SmsPreviewR400, } from './components_r400';
// Version-based component mappings for future extensibility
const VERSION_COMPONENT_MAPPINGS = {
    // Default/legacy components (for versions < 400)
    0: {
        [AssetTypes.PARTICIPANT_STATUSES]: ParticipantStatusesPreview,
        [AssetTypes.PROTOCOL_SCHEDULE]: ProtocolSchedulePreview,
        [AssetTypes.SIGN_IN_STUDY_NAME_PII]: StudyNameWithPIIPreview,
        [AssetTypes.SIGN_IN_STUDY_NAME]: StudyNameWithNoPIIPreview,
        [AssetTypes.SITE_VISIT_SCHEDULE]: SiteVisitSchedulePreview,
        [AssetTypes.SIGN_IN_SUPPORT_INFORMATION]: SignInSupportInformationPreview,
        [AssetTypes.RESOURCES]: ResourcesPreview,
        [AssetTypes.ACTIVITY_NAMES]: ActivityNamesPreview,
        [AssetTypes.RESOURCE_TITLES]: ResourceTitlesPreview,
        [AssetTypes.NOTIFICATION_PUSH_NOTIFICATION]: PushNotificationPreview,
        [AssetTypes.NOTIFICATION_EMAIL]: EmailPreview,
        [AssetTypes.NOTIFICATION_SMS]: SmsPreview,
    },
    // R400 components (for versions >= 400)
    400: {
        [AssetTypes.PARTICIPANT_STATUSES]: ParticipantStatusesPreviewR400,
        [AssetTypes.PROTOCOL_SCHEDULE]: ProtocolSchedulePreviewR400,
        [AssetTypes.SIGN_IN_STUDY_NAME_PII]: StudyNameWithPIIPreviewR400,
        [AssetTypes.SIGN_IN_STUDY_NAME]: StudyNameWithNoPIIPreviewR400,
        [AssetTypes.SITE_VISIT_SCHEDULE]: SiteVisitSchedulePreviewR400,
        [AssetTypes.SIGN_IN_SUPPORT_INFORMATION]: SignInSupportInformationPreviewR400,
        [AssetTypes.RESOURCES]: ResourcesPreviewR400,
        [AssetTypes.ACTIVITY_NAMES]: ActivityNamesPreviewR400,
        [AssetTypes.RESOURCE_TITLES]: ResourceTitlesPreviewR400,
        [AssetTypes.NOTIFICATION_PUSH_NOTIFICATION]: PushNotificationPreviewR400,
        [AssetTypes.NOTIFICATION_EMAIL]: EmailPreviewR400,
        [AssetTypes.NOTIFICATION_SMS]: SmsPreviewR400,
    },
    520: {
        [AssetTypes.SIGN_IN_STUDY_NAME_MIX_PII]: StudyNameWithMixPIIPreviewR520,
        [AssetTypes.SIGN_IN_STUDY_NAME_PII]: StudyNameWithPIIPreviewR520,
    },
};
export function getApplicableVersion(productVersion = '') {
    // Extract version number from format like 'r433', 'r444', 'r420', etc.
    const versionMatch = productVersion.match(/^r(\d+)$/i);
    const versionNumber = versionMatch ? parseInt(versionMatch[1], 10) : 0;
    // Find the appropriate version mapping
    // Sort versions in descending order to find the highest applicable version
    const sortedVersions = Object.keys(VERSION_COMPONENT_MAPPINGS)
        .map(Number)
        .sort((a, b) => b - a);
    // Find the first version that is <= the requested version
    const applicableVersion = sortedVersions.find((version) => version <= versionNumber) || 0;
    return applicableVersion;
}
export function getPreviewComponents(productVersion = '') {
    const applicableVersion = getApplicableVersion(productVersion);
    return VERSION_COMPONENT_MAPPINGS[applicableVersion];
}
export function getApplicableVersionByAssetType(productVersion = '', assetType) {
    // Extract version number from format like 'r433', 'r444', 'r420', etc.
    const versionMatch = productVersion.match(/^r(\d+)$/i);
    const versionNumber = versionMatch ? parseInt(versionMatch[1], 10) : 0;
    // Sort versions in descending order to find the highest applicable version
    const sortedVersions = Object.keys(VERSION_COMPONENT_MAPPINGS)
        .map(Number)
        .sort((a, b) => b - a);
    // Find the first version that is <= the requested version and has the asset type mapping
    for (const version of sortedVersions) {
        if (version <= versionNumber) {
            const versionMapping = VERSION_COMPONENT_MAPPINGS[version];
            if (versionMapping && versionMapping[assetType]) {
                return version;
            }
        }
    }
    // Fallback to 0 if no mapping found
    return 0;
}
export function getPreviewComponentByAssetType(productVersion = '', assetType) {
    const applicableVersion = getApplicableVersionByAssetType(productVersion, assetType);
    const versionMapping = VERSION_COMPONENT_MAPPINGS[applicableVersion];
    return versionMapping === null || versionMapping === void 0 ? void 0 : versionMapping[assetType];
}
//# sourceMappingURL=preview_component_mapping.js.map